import { BaseType } from '../../base/base-type';

export class Gender extends BaseType {}
